package com.exura.features.userprofile.data.serialization

import com.exura.features.userprofile.data.remote.dto.DoctorProfileDto
import com.exura.features.userprofile.data.remote.dto.OrganizationProfileDto
import com.exura.features.userprofile.data.remote.dto.UserSettingsBaseDto
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass

val providerProfileSerializersModule = SerializersModule {
    polymorphic(UserSettingsBaseDto::class) {
        subclass(DoctorProfileDto::class)
        subclass(OrganizationProfileDto::class)
    }
}
